import './App.css';

// ─── Update these with your real projects ───────────────────────────────────
const projects = [
  {
    title: 'venki.me',
    description:
      'Personal portfolio website — the very page you\'re viewing! Built with React and Tailwind CSS with a focus on clean, minimal design.',
    tags: ['React', 'Tailwind CSS', 'JavaScript'],
    github: 'https://github.com/venkikgit/venki.me',
    live: 'https://venki.me',
  },
  // {
  //   title: 'Project Two',
  //   description:
  //     'Describe what you built, the problem it solved, and the technologies you used. What made this interesting to work on?',
  //   tags: ['Node.js', 'Express', 'PostgreSQL'],
  //   github: '#',
  //   live: '#',
  // },
  // {
  //   title: 'Project Three',
  //   description:
  //     'What was the impact? Did you save time, automate something tedious, or build a tool people actually enjoy using?',
  //   tags: ['Python', 'FastAPI', 'Docker'],
  //   github: '#',
  // },
];

// ─── Update with your actual tech stack ─────────────────────────────────────
const skills = [
  'JavaScript', 'TypeScript',
  'React', 'Node.js',
  'Java', 'HTML & CSS',
  'Tailwind CSS', 'Bootstrap','Git',
  'REST APIs', 'SQL',
  'MongoDB', 'Linux',
  'AWS',"Serverless",
  "Docker"
];

// ─── Icons ───────────────────────────────────────────────────────────────────
function IconFolder() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" />
    </svg>
  );
}

function IconGitHub() {
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
    </svg>
  );
}

function IconExternal() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

function IconMail() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
}

// ─── Navbar ──────────────────────────────────────────────────────────────────
function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <a href="#hero" className="navbar-logo">venki.me</a>
        <div className="navbar-links">
          {['About', 'Projects', 'Contact'].map(item => (
            <a key={item} href={`#${item.toLowerCase()}`} className="nav-link">
              {item}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}

// ─── Hero ─────────────────────────────────────────────────────────────────────
function Hero() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-glow" />
      <div className="max-w-5xl mx-auto w-full px-6 pt-24">
        <p className="hero-eyebrow fade-in">Hi there, I'm</p>
        <h1 className="hero-name fade-in" style={{ animationDelay: '0.1s' }}>
          Venkateswarlu
        </h1>
        <h1 className="hero-name gradient-text fade-in" style={{ animationDelay: '0.2s' }}>
          Kolagani.
        </h1>
        <p className="hero-tagline fade-in" style={{ animationDelay: '0.3s' }}>
          Software developer who loves crafting clean,{' '}
          <br className="hidden md:block" />
          thoughtful digital experiences from idea to deployment.
        </p>
        <div className="hero-actions fade-in" style={{ animationDelay: '0.4s' }}>
          <a href="#projects" className="btn-primary">See my work</a>
          <a href="mailto:hello@venki.me" className="btn-secondary">Say hello</a>
        </div>
      </div>
    </section>
  );
}

// ─── Section heading helper ───────────────────────────────────────────────────
function SectionHeader({ number, title }) {
  return (
    <div className="section-header">
      <span className="section-number">{number}.</span>
      <h2 className="section-title">{title}</h2>
      <div className="section-line" />
    </div>
  );
}

// ─── About ───────────────────────────────────────────────────────────────────
function About() {
  return (
    <section id="about" className="section">
      <div className="max-w-5xl mx-auto px-6">
        <SectionHeader number="01" title="About Me" />
        <div className="about-grid">
          <div className="about-bio">
            <p className="bio-text">
              I'm a software developer with a passion for building things that live on the internet.
              I enjoy the full process — from thinking through the problem, to writing clean and
              maintainable code, to shipping something that actually works.
            </p>
            <p className="bio-text">
              I'm comfortable working across the stack and I'm always learning — whether it's
              picking up a new framework, diving into system design, or exploring what's possible
              with modern tooling.
            </p>
            <p className="bio-text">
              Right now I'm focused on building my skills and shipping projects.
              I'm open to opportunities where I can contribute, collaborate, and grow.
            </p>
          </div>
          <div className="about-skills">
            <p className="skills-label">Technologies</p>
            <ul className="skills-list">
              {skills.map(skill => (
                <li key={skill} className="skill-item">
                  <span className="skill-arrow">▹</span>
                  {skill}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── Projects ─────────────────────────────────────────────────────────────────
function Projects() {
  return (
    <section id="projects" className="section">
      <div className="max-w-5xl mx-auto px-6">
        <SectionHeader number="02" title="Projects" />
        <div className="projects-grid">
          {projects.map(project => (
            <div key={project.title} className="project-card">
              <div className="project-card-top">
                <div className="project-icon">
                  <IconFolder />
                </div>
                <div className="project-links">
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer"
                      className="project-link" aria-label="GitHub repository">
                      <IconGitHub />
                    </a>
                  )}
                  {project.live && (
                    <a href={project.live} target="_blank" rel="noopener noreferrer"
                      className="project-link" aria-label="Live demo">
                      <IconExternal />
                    </a>
                  )}
                </div>
              </div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-desc">{project.description}</p>
              <ul className="project-tags">
                {project.tags.map(tag => (
                  <li key={tag} className="project-tag">{tag}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── Contact ──────────────────────────────────────────────────────────────────
function Contact() {
  return (
    <section id="contact" className="section contact-section">
      <div className="max-w-5xl mx-auto px-6">
        <SectionHeader number="03" title="Get In Touch" />
        <div className="contact-body">
          <p className="contact-text">
            I'm currently open to new opportunities. Whether you have a project in mind,
            a question, or just want to connect — my inbox is always open.
          </p>
          <a href="mailto:hello@venki.me" className="contact-btn">
            <IconMail />
            hello@venki.me
          </a>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="max-w-5xl mx-auto px-6 footer-inner">
          <p>Designed &amp; built by Venkateswarlu Kolagani</p>
          <div className="footer-links">
            {/* Update these URLs with your real profiles */}
            <a href="https://github.com/venkikgit" target="_blank"
              rel="noopener noreferrer" className="footer-link">GitHub</a>
            {/* <a href="https://linkedin.com/in/venkateshkolagani" target="_blank"
              rel="noopener noreferrer" className="footer-link">LinkedIn</a> */}
          </div>
        </div>
      </footer>
    </section>
  );
}

// ─── App ──────────────────────────────────────────────────────────────────────
function App() {
  return (
    <div className="app">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <Contact />
      </main>
    </div>
  );
}

export default App;
